import CIMSFormItem from 'components/CIMSFormItem'
import DescriptionFormItem from 'components/CIMSFormItem/common/DescriptionFormItem'
import NameFormItem from 'components/CIMSFormItem/common/NameFormItem'
import UserSelect from 'components/CIMSSelect/common/UserSelect'
import { HelpMessage } from 'utils/constants'

export const CreateEditFormItems: React.FC = () => {
  const help = HelpMessage.CAS.RoutingGroups
  return (
    <>
      <NameFormItem help={help.Name} />
      <DescriptionFormItem entityName="Routing Group" />
      <CIMSFormItem name="users" label="Approvers" help={help.Approvers}>
        <UserSelect multiple />
      </CIMSFormItem>
    </>
  )
}
